import { Head } from '@/components/Head';
import { PublicLayout } from '@/components/Layout';
import { ProductsPage } from '@/features/misc';

export const Products = () => {
  return (
    <PublicLayout className="flex">
      <Head page="Product" />
      <ProductsPage />
    </PublicLayout>
  );
};
